import React from 'react';
import PropTypes from 'prop-types';
import ExpandLeft from '../../../../assets/images/iconsV2/expand_circle_left.svg';
import ExpandRight from '../../../../assets/images/iconsV2/expand_circle_right.svg';
import CloseSmall from '../../../../assets/images/iconsV2/close_small.svg';
import CloseLarge from '../../../../assets/images/iconsV2/close_large.svg';
import Expanded from '../../../../assets/images/iconsV2/expand_more.svg';
import Collapse from '../../../../assets/images/iconsV2/collapse.svg';
import SearchIcon from '../../../../assets/images/iconsV2/search.svg';
import IconPlus from '../../../../assets/images/iconsV2/add.svg';
import IconRoute from '../../../../assets/images/iconsV2/route.svg';
import HelpIcon from '../../../../assets/images/iconsV2/help.svg';
import UserGuide from '../../../../assets/images/iconsV2/user_guide.svg';
import DataGuide from '../../../../assets/images/iconsV2/data_guide.svg';
import Lightbulb from '../../../../assets/images/iconsV2/lightbulb.svg';
import ArrowForward from '../../../../assets/images/iconsV2/arrow_forward.svg';
import IconContact from '../../../../assets/images/iconsV2/contact.svg';
import OpenInNew from '../../../../assets/images/iconsV2/open_in_new.svg';
import InfoCircle from '../../../../assets/images/iconsV2/info_circle.svg';
import IconSite from '../../../../assets/images/iconsV2/site.svg';
import Share from '../../../../assets/images/iconsV2/share.svg';
import Download from '../../../../assets/images/iconsV2/download.svg';
import DownloadGreen from '../../../../assets/images/iconsV2/download_green.svg';
import Print from '../../../../assets/images/iconsV2/print.svg';
import DeleteForever from '../../../../assets/images/iconsV2/delete_forever.svg';
import Delete from '../../../../assets/images/iconsV2/delete.svg';
import NavigateNext from '../../../../assets/images/iconsV2/navigate_next.svg';
import TagsPageIcon from '../../../../assets/images/iconsV2/tag.svg';
import NotesPageIcon from '../../../../assets/images/iconsV2/note.svg';
import VisitsPageIcon from '../../../../assets/images/iconsV2/visit.svg';
import DashboardPageIcon from '../../../../assets/images/iconsV2/dashboard.svg';
import Season from '../../../../assets/images/iconsV2/season.svg';
import RequiredField from '../../../../assets/images/iconsV2/requiredField.svg';
import DescriptionIcon from '../../../../assets/images/iconsV2/description.svg';
import FileCopyIcon from '../../../../assets/images/iconsV2/file_copy.svg';
import CheckmarkIcon from '../../../../assets/images/iconsV2/checkmark.svg';
import CancelIcon from '../../../../assets/images/iconsV2/circle_x.svg';
import AlerIcon from '../../../../assets/images/iconsV2/alert.svg';
import ConfirmedIcon from '../../../../assets/images/iconsV2/confirmed.svg';
import CheckIcon from '../../../../assets/images/iconsV2/check.svg';
import NotCheckIcon from '../../../../assets/images/iconsV2/not_check.svg';
import VisibilityIcon from '../../../../assets/images/iconsV2/visibility.svg';
import HidePassword from '../../../../assets/images/iconsV2/hide_password.svg';
import Edit from '../../../../assets/images/iconsV2/edit.svg';
import VolunteerActivism from '../../../../assets/images/iconsV2/volunteer_activism.svg';
import Account from '../../../../assets/images/iconsV2/account.svg';
import AccountBlack from '../../../../assets/images/iconsV2/account_black.svg';
import AccountGreen from '../../../../assets/images/iconsV2/account_green.svg';
import OrganizationIcon from '../../../../assets/images/iconsV2/organization.svg';
import UsersPageIcon from '../../../../assets/images/iconsV2/users.svg';
import AdminIcon from '../../../../assets/images/iconsV2/admin.svg';
import addDiamond from '../../../../assets/images/iconsV2/add_diamond.svg';
import EditImage from '../../../../assets/images/iconsV2/edit_image.svg';
import CustomFields from '../../../../assets/images/iconsV2/custom_fields.svg';
import CloseModal from '../../../../assets/images/iconsV2/close_modal.svg';
import Reports from '../../../../assets/images/iconsV2/reports.svg';
import CustomFieldsDots from '../../../../assets/images/iconsV2/drag_indicator.svg';
import EditCustomFields from '../../../../assets/images/iconsV2/edit_customFields.svg';
import ExpandAll from '../../../../assets/images/iconsV2/expand_all.svg';
import Calendar from '../../../../assets/images/iconsV2/calendar.svg';
import NextArrowIcon from '../../../../assets/images/iconsV2/next_arrow.svg';
import CheckBox from '../../../../assets/images/iconsV2/check_box.svg';
import CheckBoxOutlineBlank from '../../../../assets/images/iconsV2/check_box_outline_blank.svg';
import Spinner from '../../../../assets/images/iconsV2/spinner.svg';
import IndeterminateIcon from '../../../../assets/images/iconsV2/check_indeterminate_small.svg';
import CloseTag from '../../../../assets/images/iconsV2/close_tag.svg';
import Encrypted from '../../../../assets/images/iconsV2/encrypted.svg';
import Mail from '../../../../assets/images/iconsV2/mail.svg';
import CheckCircle from '../../../../assets/images/iconsV2/check_circle.svg';
import AlertOrange from '../../../../assets/images/iconsV2/alert_orange.svg';
import ZoomToRoute from '../../../../assets/images/iconsV2/zoom_to_route.svg';
import HideOffRoute from '../../../../assets/images/iconsV2/hide_off_route.svg';
import ShowOffRoute from '../../../../assets/images/iconsV2/show_off_route.svg';
import Export from '../../../../assets/images/iconsV2/export.svg';

export const iconsDictionary = {
  expand_left: { src: ExpandLeft, alt: 'Expand Left' },
  expand_right: { src: ExpandRight, alt: 'Expand Right' },
  close_small: { src: CloseSmall, alt: 'Close Small' },
  close_large: { src: CloseLarge, alt: 'Close Large' },
  expanded: { src: Expanded, alt: 'Expanded' },
  collapse: { src: Collapse, alt: 'Collapse' },
  search: { src: SearchIcon, alt: 'Search' },
  plus: { src: IconPlus, alt: 'Icon Plus' },
  route: { src: IconRoute, alt: 'Route Icon' },
  help: { src: HelpIcon, alt: 'Help Icon' },
  user_guide: { src: UserGuide, alt: 'User Guide Icon' },
  data_guide: { src: DataGuide, alt: 'Data Guide Icon' },
  lightbulb: { src: Lightbulb, alt: 'Lightbulb Icon' },
  arrow_forward: { src: ArrowForward, alt: 'Arrow Forward Icon' },
  contact: { src: IconContact, alt: 'Contact Icon' },
  open_in_new: { src: OpenInNew, alt: 'Open In New' },
  icon_circle: { src: InfoCircle, alt: 'Info' },
  site: { src: IconSite, alt: 'Site Icon' },
  share: { src: Share, alt: 'Share' },
  download: { src: Download, alt: 'Download' },
  download_green: { src: DownloadGreen, alt: 'Download Green' },
  print: { src: Print, alt: 'Print' },
  delete_forever: { src: DeleteForever, alt: 'Delete' },
  delete: { src: Delete, alt: 'Delete' },
  navigate_next: { src: NavigateNext, alt: 'Navigate Next' },
  tags: { src: TagsPageIcon, alt: 'Tags page icon' },
  notes: { src: NotesPageIcon, alt: 'Notes page icon' },
  visits: { src: VisitsPageIcon, alt: 'visits page icon' },
  dashboard: { src: DashboardPageIcon, alt: 'Dashboard page icon' },
  season: { src: Season, alt: 'Season icon' },
  required_field: { src: RequiredField, alt: 'Required field icon' },
  description: { src: DescriptionIcon, alt: 'Description Icon' },
  file_copy: { src: FileCopyIcon, alt: 'File Copy Icon' },
  checkmark: { src: CheckmarkIcon, alt: 'Checkmark Icon' },
  circle_x: { src: CancelIcon, alt: 'Cancel Icon' },
  alert: { src: AlerIcon, alt: 'Alert icon' },
  confirmed: { src: ConfirmedIcon, alt: 'Confirmed icon' },
  check: { src: CheckIcon, alt: 'Check icon' },
  not_check: { src: NotCheckIcon, alt: 'Not check icon' },
  visibility: { src: VisibilityIcon, alt: 'Visibility icon' },
  hide_password: { src: HidePassword, alt: 'Hide password icon' },
  edit: { src: Edit, alt: 'Edit' },
  volunteer_activism: { src: VolunteerActivism, alt: 'Volunteer Activism' },
  account: { src: Account, alt: 'Account icon' },
  account_black: { src: AccountBlack, alt: 'Black Account icon' },
  account_green: { src: AccountGreen, alt: 'Green Account icon' },
  organization: { src: OrganizationIcon, alt: 'Organization Icon' },
  users: { src: UsersPageIcon, alt: 'Users Page Icon' },
  admin: { src: AdminIcon, alt: 'Admin Page Icon' },
  add_diamond: { src: addDiamond, alt: 'Customize Forms' },
  edit_image: { src: EditImage, alt: 'Edit Image' },
  custom_fields: { src: CustomFields, alt: 'Custom Fields' },
  close_modal: { src: CloseModal, alt: 'Close Modal' },
  reports: { src: Reports, alt: 'Reports' },
  drag_indicator: { src: CustomFieldsDots, alt: 'drag_indicator' },
  edit_customFields: { src: EditCustomFields, alt: 'edit_customFields' },
  expand_all: { src: ExpandAll, alt: 'expand_all' },
  calendar: { src: Calendar, alr: 'calendar' },
  next_arrow: { src: NextArrowIcon, alt: 'Next Arrow Icon' },
  check_box: { src: CheckBox, alt: 'Checkbox Icon' },
  check_box_outline_blank: { src: CheckBoxOutlineBlank, art: 'Checkbox_outline Icon' },
  spinner: { src: Spinner, alt: 'Spinner' },
  check_indeterminate_small: { src: IndeterminateIcon, alt: 'IndeterminateCheck' },
  close_tag: { src: CloseTag, alt: 'Close Tag' },
  encrypted: { src: Encrypted, alt: 'Encrypted' },
  mail: { src: Mail, alt: 'Mail' },
  check_circle: { src: CheckCircle, alt: 'Check Circle' },
  alert_orange: { src: AlertOrange, alt: 'Alert Orange' },
  zoom_to_route: { src: ZoomToRoute, alt: 'Zoom to Route' },
  hide_off_route: { src: HideOffRoute, alt: 'Hide Off Route' },
  show_off_route: { src: ShowOffRoute, alt: 'Show Off Route' },
  export: { src: Export, alt: 'Export' },
};

const Icon = ({ name = 'expand_left', className = '', dataTestId = undefined }) => {
  const { src, alt } = iconsDictionary[name] || { src: null, alt: null };

  return <img src={src} alt={alt} className={className} data-testid={dataTestId} />;
};

Icon.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
};

export default Icon;
